import { call, put, takeLatest } from 'redux-saga/effects';
import { protectedJsonPatch } from '../../../utils/api';
import {
  PROJECTS_UPDATE_PROJECT_FIELD_VALUE_BEGIN,
  PROJECTS_UPDATE_PROJECT_FIELD_VALUE_SUCCESS,
  PROJECTS_UPDATE_PROJECT_FIELD_VALUE_FAILURE,
  PROJECTS_UPDATE_PROJECT_FIELD_VALUE_DISMISS_ERROR,
} from './constants';
import { updateProjectField } from '../utils/projectUtils';

export function updateProjectFieldValue(accountId, projectId, field, analyticsPayload) {
  return {
    type: PROJECTS_UPDATE_PROJECT_FIELD_VALUE_BEGIN,
    accountId,
    projectId,
    field,
    analyticsPayload,
  };
}

export function dismissUpdateProjectFieldValueError() {
  return {
    type: PROJECTS_UPDATE_PROJECT_FIELD_VALUE_DISMISS_ERROR,
  };
}

export function* doUpdateProjectFieldValue(action) {
  const { accountId, projectId, field, analyticsPayload } = action;
  try {
    yield call(protectedJsonPatch, `accounts/${accountId}/projects/${projectId}/project-field-values/${field.id}`, { values: field.values });
  } catch (err) {
    yield put({
      type: PROJECTS_UPDATE_PROJECT_FIELD_VALUE_FAILURE,
      data: { error: err },
    });
    return;
  }

  yield put({
    type: PROJECTS_UPDATE_PROJECT_FIELD_VALUE_SUCCESS,
    projectId,
    data: field,
    analyticsPayload,
  });
}

export function* watchUpdateProjectFieldValue() {
  yield takeLatest(PROJECTS_UPDATE_PROJECT_FIELD_VALUE_BEGIN, doUpdateProjectFieldValue);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case PROJECTS_UPDATE_PROJECT_FIELD_VALUE_BEGIN:
      return {
        ...state,
        updateProjectFieldValuePending: true,
        updateProjectFieldValueError: null,
      };

    case PROJECTS_UPDATE_PROJECT_FIELD_VALUE_SUCCESS: {
      const { projectId, data } = action;
      const { projectFieldValues, filteredProjects, projectSelections } = state;

      const newProjectFieldValues = projectFieldValues.map((project) => {
        if (project.projectId === projectId) {
          return updateProjectField(project, data);
        }
        return project;
      });

      if (!projectFieldValues.some(project => project.projectId === projectId)) {
        newProjectFieldValues.push({
          projectId,
          fields: [data],
        });
      }

      const newFilteredProjects = filteredProjects.map((project) => {
        if (project.id === projectId) {
          const updatedProjectFields = newProjectFieldValues.find(p => p.projectId === projectId);
          const newFields = updatedProjectFields ? updatedProjectFields.fields : project.fields;
          return {
            ...project,
            fields: newFields,
          };
        }
        return project;
      });

      const newProjectSelections = { ...projectSelections };
      Object.keys(newProjectSelections).forEach((selectionId) => {
        const selectedProject = newProjectSelections[selectionId];
        if (selectedProject && selectedProject.id === projectId) {
          const updatedProject = updateProjectField(selectedProject, data);
          newProjectSelections[selectionId] = {
            ...updatedProject,
          };
        }
      });

      return {
        ...state,
        projectFieldValues: newProjectFieldValues,
        updateProjectFieldValuePending: false,
        updateProjectFieldValueError: null,
        filteredProjects: newFilteredProjects,
        projectSelections: newProjectSelections,
      };
    }

    case PROJECTS_UPDATE_PROJECT_FIELD_VALUE_FAILURE:
      return {
        ...state,
        updateProjectFieldValuePending: false,
        updateProjectFieldValueError: action.data.error,
      };

    case PROJECTS_UPDATE_PROJECT_FIELD_VALUE_DISMISS_ERROR:
      return {
        ...state,
        updateProjectFieldValueError: null,
      };

    default:
      return state;
  }
}
